import store from 'store2';
import constants from './constants';

/*
 * 「Surveyへ回答した」という状態をLocalStorageに保存する
 *
 * @param {number} keepDays - 保存する日数
 */
const answerToSurvey = keepDays => {
  store(constants.SURVEY_STATE_NAME, constants.SURVEY_STATE_VALUE_ANSWERED);
  if (keepDays < 0) {
    store(constants.SURVEY_EXPIRATION_NAME, -1);
  } else {
    store(
      constants.SURVEY_EXPIRATION_NAME,
      new Date().getTime() + keepDays * 1000 * 60 * 60 * 24
    );
  }
};

export default answerToSurvey;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/answerToSurvey.js